<template>
  <section class="home-brand-strip" aria-label="Zinnes">
    <img class="home-brand-strip__logo" src="@/assets/images/zinnes2.png" alt="Zinnes" />
    <div class="home-brand-strip__copy">
      <p class="home-brand-strip__kicker">A sua plataforma de quadrinhos</p>
      <p class="home-brand-strip__text">Descubra obras autorais, acompanhe artistas e encontre sua próxima leitura.</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeBrandStrip",
};
</script>
